import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { App } from "./App";
import { restoreAfterSignin } from "./lib/auth";
import { oidcConfig } from "./lib/config";
// Self-hosted brand faces (latin subset, only the weights styles.css uses), so
// staff browsers never contact Google Fonts. Vite fingerprints the woff2 files.
import "@fontsource/jost/latin-400.css";
import "@fontsource/jost/latin-500.css";
import "@fontsource/jost/latin-600.css";
import "@fontsource/cormorant-garamond/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* onSigninCallback strips the OIDC query and restores the address the
        sign-in started from -- a deep link, or the Xero callback's ?xero=…
        outcome, which the Clients page reads on its first render. */}
    <AuthProvider {...oidcConfig} onSigninCallback={restoreAfterSignin}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
